/**
 * User: herbert
 * Date: 09.02.16
 * Time: 11:02
 */

import svgData from 'svg2js-data';
import {Base64} from 'js-base64/base64';

import steleStore from './stores/stele-store.js';

function head(w, h) {
	return '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" '+
			'width="'+w+'px" height="'+h+'px" viewBox="0 0 '+w+' '+h+'" style="enable-background:new 0 0 '+w+' '+h+';" xml:space="preserve">';
}

const fin = '</svg>';

const SteleSVG = {
	inverted: false,
	color: 'rgb(235,235,235)', // nicht '#EBEBEB', stattdessen wegen Firefox immer rgb()-Syntax, also 'rgb(235,235,235)'
	getSteleStyle: function(part) {
		return '.stele{fill:'+ (this.inverted?'rgb(38,38,38)':this.color) +
				';stroke:'+(this.inverted?'white'+';stroke-width:'+(part?'0.5':'0.1'):'black'+';stroke-width:'+(part?'1':'0.2'))+';}';
	},
	/**
	 * @param{Array.<String>} additional 	styles additional to the .stele style
	 * @return{String} svg style definition
	 */
	getStyles: function(additional) {
		let ret = '<style type="text/css">';
		if(additional) ret += additional;
		return ret + this.getSteleStyle(true) + '</style>';
	},
	/**
	 * get an svg of the stele base
	 * @param{Number} height over all height in mm
	 * @param{Number} size	size of elements sitting on top of the base in stele-svg-pixel (76 per 1000mm)
	 * @param{Number} [withHeight] create image for height screen, add 250 mm to height3000 and take this as picture height
	 * @param{Boolean} [datasheet]  same stele as using withHeight, but if true don't write height
	 * @param{Boolean} [fr] region fr: if writing minimum base height (withHeight && !datasheet), write it at 2500mm instead of 3000mm
	 * @return{String} data url containing svg
	 */
	getStele: function(height, size, withHeight, datasheet, fr) {
		return 'data:image/svg+xml;utf8,' + this.getSteleInternal(height, size, withHeight, datasheet, fr);
	},
	getSteleIE: function(height, size, withHeight, datasheet, fr) {
		return 'data:image/svg+xml;base64,' + Base64.encode(this.getSteleInternal(height, size, withHeight, datasheet, fr));
	},
	/**
	 * get an svg of the stele base
	 * @param{Number} height over all height in mm
	 * @param{Number} size	size of elements sitting on top of the base in stele-svg-pixel (76 per 1000mm)
	 * @param{Number} [withHeight] create image for height screen, add 250 mm to height and take this as picture height
	 * @param{Boolean} [datasheet]  same stele as using withHeight, but if true don't write height
	 * @param{Boolean} [fr] region fr: if writing minimum base height (withHeight && !datasheet), write it at 2500mm instead of 3000mm
	 * @return{String} svg
	 */
	getSteleInternal: function(height, size, withHeight, datasheet, fr) {
		const h = height * 76/1000.0; // +19; size+=19;
        // h3000: Markierung für 3m
		const h8000 = 0;
		const h3000 = (5000 - steleStore.getPartsHeight()) * 76/1000.0;
		const px3000 = h3000 + size + (fr ? 500*76/1000.0 : 0);
		const dy = h8000-px3000/5;
		if(withHeight) {
			const wH = (height - withHeight) * 76/1000;
			if(datasheet && size > 0)
				size -= 3;
			return head(304, h + 19) +
					'<style type="text/css">' + this.getSteleStyle() +
						'@font-face{font-family:"LLBrown";font-weight:400;src:url(fonts/lineto-brown-pro-regular.eot);src:url(fonts/lineto-brown-pro-regular.eot?) format("embedded-opentype"),url(fonts/lineto-brown-pro-regular.ttf) format("truetype"),url(../fonts/lineto-brown-pro-regular.woff) format("woff");}' +
						'text{font-size:12px;font-family:LLBrown,Brown,Helvetica,Arial,sans-serif;font-weight:bold;font-weight:400;}' +
						'.st1{fill:none;stroke:black;stroke-width:1;}' +
						'.stL{fill:none;stroke:'+(datasheet?'black':'red')+';stroke-width:.5;}' +
					'</style>' +
				'<text x="312" y="'+(19 + h -1 )+'">0 mm</text>'+
					(datasheet ?
					   ('<line class="stL" x1="167" x2="302" y1="' + (19 + wH + 1) + '" y2="' + (19 + wH + 1) + '"/>' +
					    '<text x="312" y="' + (19 + wH) + '">' + withHeight + ' mm</text>' +
					    '<rect x="146.5" y="' + (19 + wH + size) + '" class="stele" width="11.5" height="' + (h - wH - size) + '" />') : // das Mast-Basis-Element: das wird mit Bezug zum 0-Punkt ein bissl falsch gezeichnet
					   ('<line class="st1" x1="167" x2="302" y1="' + (19 + wH + 1) + '" y2="' + (19 + wH + 1) + '"/>' +
					    '<text text-anchor="end" x="137" y="' + (19 + wH) + '">' + withHeight + ' mm</text>' +
					    '<text x="312" y="'+(19 + h8000)+'">8000 mm</text>'+
					    '<text x="312" y="'+(19 + px3000 )+'">'+(fr?'2500':'3000')+' mm</text>'+
					    '<line x1="168" x2="302" y1="' + (19 + h8000 +1) +'" y2="' + (19 + px3000 + 5*dy +1) +'" class="stL" />' +
					    '<line x1="168" x2="302" y1="' + (19 + px3000 +1) +'" y2="' + (19 + px3000 +1) +'" class="stL" />' +
					    '<rect x="146" y="' + (19 + wH + size) + '" class="stele" width="12" height="' + (h - wH - size) + '" />' + // das Mast-Basis-Element: das wird mit Bezug zum 0-Punkt ein bissl falsch gezeichnet
						'<rect fill="black" x="300" y="' + (19 + wH - 1) + '" width="4" height="4" />' +
						'<line class="st1" x1="302" x2="302" y1="' + (19 + wH + 1) + '" y2="' + (19 + wH + h + 1) + '"/>') ) +
					fin;
		} else {
			return head(14, h) +
					'<style type="text/css">' + this.getSteleStyle() + '</style>' +
					'<rect x="1" y="' + (size) + '" class="stele" width="12" height="' + (h - size) + '" />' +
					fin;
		}
	},
	/**
	 * fetch svg for some stele part
	 * @param{String} name	name of part
	 * @param{Number} r			rotation
	 * @param{Number} cover  null or 0: N/A, 1: without Backcover 2: with BackCover
     * @return{String} data url containing svg
	 */
	getPart: function(name, r, cover) {
	  return 'data:image/svg+xml;utf8,' + this.getPartInternal(name, r, cover);
	},
	getPartIE: function(name, r, cover) {
		return 'data:image/svg+xml;base64,' + Base64.encode(this.getPartInternal(name, r, cover));
	},
	/**
	 * fetch svg for some stele part
	 * @param{String} name	name of part
	 * @param{Number} r			rotation
	 * @param{Number} cover  null or 0: N/A, 1: without Backcover 2: with BackCover
	 * @return{String} svg
	 */
	getPartInternal: function(name, r, cover) {
		let data;
		if(cover>0) {
			data = (cover > 1) ? svgData['mit'][name][r/5] : svgData['ohne'][name][r/5];
		} else {
			data = (svgData[name] instanceof Array) ? svgData[name][r!==undefined?(r%360)/5:0] : svgData[name];
		}
		if(!data) console.log(data, name, r, cover, svgData[name]);
		return head(data.w, data.h)+this.getStyles(data.css)+data.body+fin;
	}
};

const ie = /Trident/.test(navigator.userAgent) || /Edge/.test(navigator.userAgent);

if(ie) {
	console.log('adapting to ie');
	SteleSVG.getPart = SteleSVG.getPartIE;
	SteleSVG.getStele = SteleSVG.getSteleIE;
}

export default SteleSVG;
